'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDynamicDataLoader = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = void 0;
if (typeof __TEST__ !== 'undefined' && __TEST__) {
  // Have to use a global during test, as the file-local variable `cache`
  // gets blown away on every file change when watching test files with
  // mocha.
  if (!global.dynamicDataCache) {
    global.dynamicDataCache = new _map2.default();
  }
  cache = global.dynamicDataCache;
} else if (typeof __CLIENT__ !== 'undefined' && __CLIENT__) {
  cache = new _map2.default(window.dynamicData);
  if (cache.size === 0) {
    throw new Error('could not find dynamic data map');
  }
} else {
  cache = new _map2.default();
}

var makeDynamicDataLoader = exports.makeDynamicDataLoader = function makeDynamicDataLoader(name, fn) {
  var getter = function getter() {
    return cache.get(name);
  };
  getter.cacheName = name;
  return {
    get: getter,
    load: function load() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _promise2.default.resolve(cache.has(name) ? cache.get(name) : fn.apply(undefined, [function (data) {
        return cache.set(name, data);
      }].concat(args)));
    }
  };
};